import React from 'react'
import TextField from '@mui/material/TextField'

import {
  PROFILE_INFO_COPY,
  profileInfoReadOnlyEmptyFieldSx,
  profileInfoReadOnlyFieldSx
} from '../constants/profileInfoConstants'

export default function ProfileInfoReadValue({ value }) {
  const hasValue = Boolean(value)

  return (
    <TextField
      fullWidth
      size="small"
      disabled
      value={value || PROFILE_INFO_COPY.emptyValue}
      sx={{
        ...profileInfoReadOnlyFieldSx,
        ...(!hasValue ? profileInfoReadOnlyEmptyFieldSx : {})
      }}
    />
  )
}
